module.exports = __webpack_public_path__ + "img/mc.f9786e0c.png";